import { theme } from '@kvdbil/components';
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    font-synthesis: none;
    text-rendering: optimizeLegibility;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
  }

  body, html {
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: ${theme.colors.background.gray};
    font-family: 'Open Sans', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

::-webkit-scrollbar {
  display: none;
}

/* Handle on hover */

  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active{
      box-shadow: 0 0 0 30px ${theme.colors.grayscaleToned.light6} inset !important;
      -webkit-box-shadow: 0 0 0 30px #fefefe ${theme.colors.grayscaleToned.light6} !important;
  }

  input:-webkit-autofill{
    -webkit-text-fill-color: ${theme.colors.text.dark} !important;
}

  #root {
    height: 100%;
  }

  a {
    text-decoration: none;
    color: ${theme.colors.info.main};
  }

  ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Next Book', sans-serif;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
    padding: 0;
    font-size: 1em;
    font-weight: 400;
  }

  input {
    color: ${theme.colors.text.dark};
  }

  /* LEGAL DISCLAIMER
 *
 * These Fonts are licensed only for use on these domains and their subdomains:
 * www.kvd.se
 *
 * It is illegal to download or use them on other websites.
 *
 * While the @font-face statements below may be modified by the client, this
 * disclaimer may not be removed.
 *
 * Optimo webfonts are protected by copyright law and provided under license. To modify, alter, translate, convert, decode or reverse engineer in any manner whatsoever, including converting the Font Software into a different format is strictly prohibited. The webfont files are not to be used for anything other than web font use.
 *
 * optimo.ch
 */

@font-face {
  font-family: 'Next Book';
  src: url('/fonts/NEXT-Book/NEXT-Book-Bold.eot');
  src: url('/fonts/NEXT-Book/NEXT-Book-Bold.eot?#iefix')
      format('embedded-opentype'),
    url('/fonts/NEXT-Book/NEXT-Book-Bold.woff2') format('woff2'),
    url('/fonts/NEXT-Book/NEXT-Book-Bold.woff') format('woff');
  font-weight: 700;
  font-style: normal;
  unicode-range: U+000-5FF; /* Download only latin glyphs */
  font-display: swap;
}

@font-face {
  font-family: 'Next Book';
  src: url('/fonts/NEXT-Book/NEXT-Book-Regular.eot');
  src: url('/fonts/NEXT-Book/NEXT-Book-Regular.eot?#iefix')
      format('embedded-opentype'),
    url('/fonts/NEXT-Book/NEXT-Book-Regular.woff2') format('woff2'),
    url('/fonts/NEXT-Book/NEXT-Book-Regular.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  unicode-range: U+000-5FF; /* Download only latin glyphs */
  font-display: swap;
}
`;

export default GlobalStyles;
